
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    isAmount: {
      type: Boolean,
      default: () => true,
    },
  },
  setup(props) {
    return {
      props,
    }
  },
})
